<div class="template-details" [formGroup]="detailsFormGroup">
  <div class="details-grid">
    <sc-dictionary-field [model]="details.name" [defaultLabel]="'name'" style="grid-column: 1; grid-row: 1;"
      (dictionaryChanged)="onDataDictionaryChanged($event)"
      [labelDictionaryKey]="'tmc-yard.entity.document-template.name'" [required]="false" [maxlength]="255">
    </sc-dictionary-field>
    <mat-form-field style="grid-column: 1; grid-row: 2;">
      <input matInput name="titlePattern" formControlName="titlePattern"
        placeholder="{{'title pattern' | translate:['tmc-yard.entity.document-template.title-pattern', translationService.language]}}"
        [required]="false" [maxLength]="255">
    </mat-form-field>
  </div>
</div>